import { Theme, Typography, styled } from '@material-ui/core';

const SeriesCardTypeInfo = styled(Typography)<Theme>(({ theme }) => ({
  marginTop: theme.spacing(2),
  fontSize: theme.typography.h4.fontSize,
  fontWeight: 400,
  fontStyle: 'italic',
  color: theme.palette.primary.main,
}));

export default SeriesCardTypeInfo;
